import { createSharedState } from '@pinian/shared-state'
import type { Pinia } from 'pinia'

export default defineNuxtPlugin((nuxtApp) => {
  if (typeof BroadcastChannel === 'undefined') {
    return
  }

  const pinia = nuxtApp.$pinia as Pinia | undefined
  if (!pinia || typeof pinia.use != 'function') return

  const runtimeConfig = useRuntimeConfig()
  pinia.use(createSharedState({
    auto: false,
    channel: id => `v1.0.0--${id}-${runtimeConfig.public.environment}`,
    instant: true,
    mergeStrategy: 'deep'
  }))
})
